// @ts-check
import React, { StatelessComponent } from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import moment from 'moment';
import { ProviderMappingResult } from '../types'; // eslint-disable-line no-unused-vars
import classes from './NoSlotsAvailablePicker.module.scss';

const DAYS = [0, 1, 2, 3, 4].map(i => moment().add(i, 'days'));

const dayHeadings = DAYS.map(m => {
  const formattedDay = m.format('ddd');
  const formattedDate = m.format('M/D/YY');
  const key = `day-name-key-${formattedDate}`;

  return (
    <li key={key}>
      <span className={classes.day_name}>{formattedDay}</span> {formattedDate}
    </li>
  );
});

/** @typedef {{
  matchingResult: ProviderMappingResult,
  onProviderClick: (result: ProviderMappingResult) => void
}} NoSlotsAvailablePickerPropsType */

/** @type { React.ValidationMap<NoSlotsAvailablePickerPropsType> } */
const propTypes = {
  matchingResult: PropTypes.object.isRequired,
  onProviderClick: PropTypes.func.isRequired,
};

/** @type { StatelessComponent<NoSlotsAvailablePickerPropsType> } */
const NoSlotsAvailablePicker = ({ matchingResult, onProviderClick }) => (
  <div className={classes.NoSlotsAvailablePicker}>
    <div className={classes.date_headers}>
      <ul>{dayHeadings}</ul>
    </div>
    <div className={classes.day_columns_section}>
      <table className={classes.slots_table}>
        <tbody>
          <tr>
            {DAYS.map(d => (
              <td key={d.toString()} className={classes.day_column} />
            ))}
          </tr>
        </tbody>
      </table>
    </div>
    <div className={classes.coverup}>
      <div>
        <h3>Direct Scheduling Not Yet Available</h3>
        <a onClick={() => onProviderClick(matchingResult)} className="outlined-action-button">
          Send Referral
        </a>
      </div>
    </div>
  </div>
);

NoSlotsAvailablePicker.displayName = 'NoSlotsAvailablePicker';
NoSlotsAvailablePicker.propTypes = propTypes;

export default NoSlotsAvailablePicker;
